import { socket } from '#GameFrontend/services/socket';
import moment from 'moment';
import React, { createContext, useContext, useEffect, useState } from 'react';

interface GameConfig {
	dayZero: string; // ISO string date
	version: string;
	majorVersionName: string;
	active: boolean;
	registrationClosed: boolean;
	registrationWithKey: boolean;
	// Computed properties
	getFullGameMonths: () => number;
	getGameMonths: () => number;
	getGameYears: () => number;
}

interface GameConfigContextType {
	config: GameConfig | null;
	isLoading: boolean;
}

const GameConfigContext = createContext<GameConfigContextType>({
	config: null,
	isLoading: true,
});

export const useGameConfig = () => useContext(GameConfigContext);

export const GameConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [config, setConfig] = useState<GameConfig | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		socket.emit('Config:Get');
		socket.on('Config:Get', (data) => {
			// Add computed properties to the config object
			const configWithComputed = {
				...data.data,
				getFullGameMonths: () => {
					const dayZero = moment(data.data.dayZero);
					return moment().diff(dayZero, 'days');
				},
				getGameMonths: () => {
					const dayZero = moment(data.data.dayZero);
					return moment().diff(dayZero, 'days') % 12;
				},
				getGameYears: () => {
					const dayZero = moment(data.data.dayZero);
					return Math.floor(moment().diff(dayZero, 'days') / 12);
				},
			};
			setConfig(configWithComputed);
			setIsLoading(false);
		});

		socket.on('Config:Update', (data) => {
			setConfig(data.data);
		});

		return () => {
			socket.off('Config:Get');
			socket.off('Config:Update');
		};
	}, []);

	return <GameConfigContext.Provider value={{ config, isLoading }}>{children}</GameConfigContext.Provider>;
};
